import React from 'react';
import Text from '../base/Text';

const TooltipTitle = ({ boldText, text, size = 'large' }) => {
  return (
    <>
      <Text size={size} weight={500}>
        {boldText}
      </Text>
      &nbsp;&nbsp;
      <Text size={size} color='shuttleGray'>
        {text}
      </Text>
    </>
  );
};

export default TooltipTitle;
